<div class="container">
  <mat-tab-group
    [selectedIndex]="selected.value"
    (selectedTabChange)="selectedValue($event)">
    <mat-tab label="Histórico Salidas">
        <div  class="mt-4">
          <data-table
            title="Historico Salidas Inventario"
            [columns]='columnsOI'
            [configuration]='configurationOI'
            [reloadTable]='reloadTablaOI'
            [params]='[]'
            [url]='urlTableOI'
            (add)='addOI($event)'
            (view)='viewDetail($event)'
            [headerFilters]="headerFilters"
            [headerFileXlsm]="headerFileXlsm"
          ></data-table>
        </div>
    </mat-tab>

    <mat-tab *ngIf="selected.value == 1 || selected.value == 2" label="Salida">
          <div style="width: 100%">
            <app-button-label [labelsEdit]="labels">
            </app-button-label>
            <data-table
              title="Salida"
              [columns]="columnsDetails"
              [data]="dataDetails"
              [configuration]="configurationDetails"
              [reloadTable]="reloadTablaDetails"
              [headerFileXlsm]="headerDetailsFileXlsm"
            >
            </data-table>
          </div>
    </mat-tab>

    <mat-tab *ngIf="detailsClickRow.workOrderId > 0 && (selected.value == 1 || selected.value == 2)" label="Detalle Orden">
      <app-work-order-summary
      [workOrderDetails]="detailsClickRow">
      </app-work-order-summary>
    </mat-tab>

  </mat-tab-group>
</div>
